import { APP_INITIALIZER, EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { CognitoService, cognitoPreferencesStorage } from '@cnt-workspace/data-access';

/**
 * Providers the cnt-landing AuthService needs at boot, mirroring
 * apps/cnt-landing/src/app/app.config.ts: its CognitoService fork, and a
 * hydrate of the Preferences-backed Cognito session cache before any route
 * (and so adminGuard) resolves.
 */
export function provideAdminAuth(): EnvironmentProviders {
  return makeEnvironmentProviders([
    CognitoService,
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: () => () => cognitoPreferencesStorage.hydrate(),
    },
  ]);
}
